import { connect } from 'react-redux';
import Page from './Page';
import { viewEnter } from '../actions';
import { isViewLoading } from '../selectors';

const mapStateToProps = state => ({
  isLoading: isViewLoading(state)
});

const mapDispatchToProps = {
  viewEnter
};

export default connect(mapStateToProps, mapDispatchToProps)(Page);
